export default "__VITE_ASSET__qelCoF8n__"